
const hideLoader = () => {
    const hideLoaderEvent = new CustomEvent( 'loader::destroy' , { detail: {
            domNode: document.body ,
            loaderType: 'fullpage'
        } } );

    document.dispatchEvent(hideLoaderEvent);
}

const showLoader = () => {
    const showLoaderEvent = new CustomEvent( 'loader::apply' , { detail: {
            domNode: document.body ,
            loaderType: 'fullpage' ,
            loaderText: `<h3>${LANG_common_processing_request}</h3>`
        } } );

    document.dispatchEvent(showLoaderEvent);
}

const manageResponse = (response) => {
    if (typeof response.has_password === 'boolean') {
        let locationSearch = window.location.search, qsParts = [];
        if (locationSearch) {
            qsParts.push('qs=' + encodeURIComponent(locationSearch));
        }
        let username = '', usernameString;
        if (typeof response.username !== 'undefined') {
            username = response.username;
            qsParts.push('username=' + response.username);
        }

        let qs = qsParts.length > 0 ? '?' + qsParts.join('&') : '';
        if (response.has_password === true) {
            showLoader();
            $.ajax({
                type: 'GET',
                url: apiUrl + '/lsapi/v1/misc/keycloakLoginPage' + qs,
                headers: {'auth-token': at},
                success: function(response) {
                    hideLoader();
                    if (typeof response.redirect_url === 'undefined') {
                        alert('An error has occurred');
                        return;
                    }

                    window.location.href = response.redirect_url;
                }
            });
        } else {
            window.location.href = apiUrl + '/cpanel/?s=&m=login&c=main&a=resetPasswordSso&em=' + encodeURIComponent(username)
        }
    } else {
        $('#p-label-warning').html(LANG_warning_sso_user_not_present).show();
    }
}

const checkEmail1 = ( val ) => {
    return ( val.match(/^([a-z0-9\-_.äöüß_\.\+-])+@(([a-z0-9_-])+\.)+[a-z]{2,6}$/i) !== null );
}

const ssoRoutines = () => {
    $("#login_user").focus();

    $('#login-form').on('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if(!checkEmail1($("#login_user").val())){
            error1($("#login_user"));
            return false;
        }

        $('#p-label-warning').hide();
        showLoader();
        $.ajax({
            type: 'GET',
            url: apiUrl + '/lsapi/v1/misc/ssoStatusCheck?email=' + encodeURIComponent($('#login_user').val()),
            headers: {'auth-token': at},
            success: function(response) {
                hideLoader();
                manageResponse(response);
            }
        });
    });

    $('#reset-password-form').on('submit', function (event) {
        event.preventDefault();
        showLoader();
        $.ajax({
            type: 'POST',
            url: apiUrl + '/lsapi/v1/misc/ssoResetPassword',
            data: 'email=' + encodeURIComponent($('#login_user').val()),
            headers: {'auth-token': at},
            success: function(response) {
                hideLoader();
                $('.label-info2').removeClass('label-error2').html(LANG_info_sso_reset_password_email_sent + '<span class="glyphicon glyphicon-thumbs-up form-control-feedback"></span>');
                $('#reset-password-form').remove();
                window.setTimeout(function() {
                    window.location.href = apiUrl + '/cpanel/';
                }, 10000);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                hideLoader();
                $('.label-info2').addClass('label-error2').html(LANG_info_sso_reset_password_email_error + '<span class="glyphicon glyphicon-thumbs-down form-control-feedback"></span>');
            }
        });
    });
}

let apiUrl = window.location.protocol + "//" + window.location.host,
    at = 'ziHlFFeGSEvDSD3YqZREOfAbzt6I6oBJq8c26uEvYySp5whizUPu6alQRgKCasz3';
$(document).ready(ssoRoutines);




// WEBPACK FOOTER //
// ./cpanel/js/pages/sso.js